import React, { useState, useEffect, useRef } from "react";
import "./puja-campaign-page.scss";
import { ToastContainer } from "react-toastify";
import { useSearchParams } from "next/navigation";
import Image from "next/image";

import Bg from "@/components/pujaCampaign2025/bg";
import Home from "@/components/pujaCampaign2025/home";
import Camera from "@/components/pujaCampaign2025/camera";
import Payment from "@/components/pujaCampaign2025/payment";
import Output from "@/components/pujaCampaign2025/output";
import logo from "@/../public/campaign/puja-2025/logo.png";

import Frame from "@/components/pujaCampaign2025/frame";
import RedirectLoader from "@/components/pujaCampaign2025/redirectLoader";

export default function PujaCampaignPage() {
  const searchParams = useSearchParams();
  const audioRef = useRef(null);
  const [capturedImg, setCapturedImg] = useState("");
  const [isMusicON, setIsMusicON] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [imageCount, setImageCount] = useState(0);
  const [currentComp, setCurrentComp] = useState("home");
  const [userId, setUserId] = useState("");
  const [bgId, setBgId] = useState("");
  const [queryParams, setQueryParams] = useState({});
  const [gender, setGender] = useState("");
  const [credits, setCredits] = useState("");
  const [showRedirectLoader, setShowRedirectLoader] = useState(true);

  const allComponents = [
    {
      name: "home",
      comp: (
        <Home
          onNextComp={setCurrentComp}
          setUserId={setUserId}
          setGender={setGender}
          setCredits={setCredits}
        />
      ),
    },
    {
      name: "bg",
      comp: <Bg onNextComp={setCurrentComp} setBgId={setBgId} />,
    },
    {
      name: "camera",
      comp: (
        <Camera
          onNextComp={setCurrentComp}
          setCapturedImg={setCapturedImg}
          credits={credits}
        />
      ),
    },
    {
      name: "payment",
      comp: (
        <Payment
          onNextComp={setCurrentComp}
          capturedImg={capturedImg}
          userId={userId}
          bgId={bgId}
          gender={gender}
        />
      ),
    },
    {
      name: "output",
      comp: (
        <Output
          onNextComp={setCurrentComp}
          capturedImg={capturedImg}
          userId={userId}
          bgId={bgId}
          gender={gender}
          params={queryParams}
        />
      ),
    },
  ];

  let getUserSelfie = async (id) => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open("PujaCampaignUserData", 1);

      request.onsuccess = function (event) {
        const db = event.target.result;
        const tx = db.transaction("userSelfie", "readonly");
        const store = tx.objectStore("userSelfie");
        const getReq = store.get(id);

        getReq.onsuccess = () => resolve(getReq.result?.img || null);
        getReq.onerror = reject;
      };

      request.onerror = reject;
    });
  };

  useEffect(() => {
    const onSuccess = async () => {
      const userId = searchParams.get("userId");
      const bgId = searchParams.get("bgId");
      const txnId = searchParams.get("txnId");
      const gender = searchParams.get("gender");
      const status = searchParams.get("status");
      if (userId && bgId && txnId && status && gender) {
        setUserId(userId);
        setBgId(bgId);
        setQueryParams({ userId, bgId, txnId, status, gender });
        let userSelfie = await getUserSelfie(1);
        setCapturedImg({ img: userSelfie });
        setCurrentComp("output");
        setGender(gender);
        setShowRedirectLoader(false);
      } else {
        console.error("missing params from payment redirect url");
        setCurrentComp("home");
        setShowRedirectLoader(false);
      }
    };
    onSuccess();
  }, [searchParams]);

  // scroll off
  useEffect(() => {
    document.documentElement.classList.add("no-scroll");
    document.body.classList.add("no-scroll");
    return () => {
      document.documentElement.classList.remove("no-scroll");
      document.body.classList.remove("no-scroll");
    };
  }, []);

  return (
    <div className="PujaCampaignPage">
      <Frame />

      <div className="flex-row-center logoContainer">
        <Image src={logo} alt="logo" />
      </div>

      {allComponents.map(
        (component) =>
          component.name === currentComp && (
            <div key={component.name} className="singleComponent">
              {component.comp}
            </div>
          )
      )}

      {showRedirectLoader && <RedirectLoader />}

      <ToastContainer />
    </div>
  );
}
